import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule } from '@spartacus/storefront';
import { FormAddressComponent } from '../../../../user/profile/components/register/components/form-address/form-address.component';
import { BehaviorSubject, Observable, of, take } from 'rxjs';
import { Option } from '../../../../../../core/models/option.model';
import { Country, I18nModule } from '@spartacus/core';
import { UserAuxService } from '../../../../user/core/user-aux.service';
import { ToasterService } from '../../../../../../components/toaster/toaster.service';

@Component({
  selector: 'form-account-details',
  standalone: true,
  imports: [CommonModule, I18nModule, ReactiveFormsModule, FormErrorsModule, FormAddressComponent],
  templateUrl: './form-account-details.component.html',
  styleUrl: './form-account-details.component.scss',
})
export class FormAccountDetailsComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() countries$: Observable<Country[]> = of([]);
  productCategories$ = new BehaviorSubject<Option[]>([]);

  constructor(
    private userAuxService: UserAuxService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.fetchProductCategories();
  }

  fetchProductCategories() {
    this.userAuxService
      .getProductCategories()
      .pipe(take(1))
      .subscribe(response => {
        if (response.hasError) {
          this.toasterService.displayError(response.message!);
        }

        this.productCategories$.next(response.options!);
      });
  }
}
